import { createApiClient } from './createApiClient';

const postalCodeClient = createApiClient('https://admin.valwin.fr');

// Public referential on another origin: no session cookie, no pharmacy namespace
const OPTIONS = {
  pharmacyId: '',
  withoutPharmacyPrefix: true,
  credentials: 'omit',
} as const;

export type PostalCodeCountry = {
  key: string;
  name: string;
  data?: string;
};

export type PostalCodeRegion = { key: string; name: string };

export type PostalCodeDepartment = { key: string; name: string };

export type PostalCodeEntry = { postal: string; city: string };

export const getCountries = () =>
  postalCodeClient.get<PostalCodeCountry[]>(
    '/api/postalCode/infos/countries',
    OPTIONS
  );

export const getCountry = (countryKey: string) =>
  postalCodeClient.get<PostalCodeCountry & { regions: PostalCodeRegion[] }>(
    `/api/postalCode/infos/country/${countryKey}`,
    OPTIONS
  );

export const getRegion = (countryKey: string, regionKey: string) =>
  postalCodeClient.get<
    PostalCodeRegion & { departments: PostalCodeDepartment[] }
  >(`/api/postalCode/infos/country/${countryKey}/region/${regionKey}`, OPTIONS);

export const getDepartment = (countryKey: string, departmentKey: string) =>
  postalCodeClient.get<
    PostalCodeDepartment & { postalCodes: PostalCodeEntry[] }
  >(
    `/api/postalCode/infos/country/${countryKey}/department/${departmentKey}`,
    OPTIONS
  );
